import { Component, Inject } from '@angular/core';
import { Router } from '@angular/router';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { PlanProtectionService } from '../../../app/service/plan-protection/plan-protection.service';

@Component({
  selector: 'app-sku-info-dialog',
  //standalone: true,
  //imports: [],
  templateUrl: './sku-info-dialog.component.html',
  styleUrl: './sku-info-dialog.component.scss'
})
export class SkuInfoDialogComponent {

  skuInfo

  constructor( 
      @Inject(MAT_DIALOG_DATA) 
      public data, 
      private planProtectionService: PlanProtectionService,
      public dialogRef: MatDialogRef<SkuInfoDialogComponent>) {
        console.log(data.ppDetalle)
    planProtectionService.getDetalleSku({sku: data.ppDetalle.sku}).subscribe(
      data => {
        this.skuInfo = data
      }
    )
  }

  ngOnInit() { }

  closeDialog() {
    this.dialogRef.close({event: 2});
  }

  save(){

    this.dialogRef.close({event: 1});
  }

}